import { useState } from "react";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { api } from "src/shared/setup/API/api";
import {
  handleDownloadPdfComissaoProdutor,
  IPdfComissaoProdutorData,
} from "./PdfComissaoProdutor";

export const UseDownloadPdfComissaoProdutor = () => {
  const { handleGetAlert } = useLayoutMainContext();
  const [loading, setLoading] = useState(false);

  const handleDownloadPdf = async (id: string) => {
    setLoading(true);

    try {
      const response = await api.get(`/comissoes/getProdutorByIdViewModal/${id}`);
      const data = response.data as IPdfComissaoProdutorData;

      // Adiciona o code se não vier na resposta
      if (!data.code) {
        data.code = id;
      }

      await handleDownloadPdfComissaoProdutor(data);

      handleGetAlert({ message: "PDF gerado com sucesso!" });
    } catch (error: any) {
      handleGetAlert({
        message: error?.response?.data?.message || "Erro ao gerar PDF",
      });
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    handleDownloadPdf,
  };
};
